import React from 'react';
import PropTypes from 'prop-types';
import cn from 'classnames';
import styles from './Button.module.scss';
import Spinner from '../Spinner';

function Button(props) {
  const { color, disabled } = props;

  const classes = [styles.container];

  if (color) {
    classes.push(styles[`color-${color}`]);
  }

  if (disabled) {
    classes.push(styles.disabled);
  }

  if (props.margin) {
    classes.push(styles.margin);
  }

  if (props.border) {
    classes.push(styles.border);
  }

  if (props.margin_left) {
    classes.push(styles.margin_left);
  }

  if (props.full_width) {
    classes.push(styles.full_width);
  }

  if (props.uppercase) {
    classes.push(styles.uppercase);
  }

  if (props.link) {
    classes.push(styles.link);
  }

  if (props.noWordBreak) {
    classes.push(styles.noWordBreak);
  }

  if (props.className) {
    classes.push(...props.className.split(' '));
  }

  return (
    <button
      className={cn(classes)}
      type={props.type}
      onClick={props.onClick}
      disabled={disabled}
      data-testid={props.testId || 'button'}
      title={props.title}
    >
      {props.loading ? <Spinner absolute size="small" /> : <span>{props.text}</span>}
    </button>
  );
}

export default Button;

Button.defaultProps = {
  type: 'button',
  margin: false,
  disabled: false,
  onClick: undefined,
  border: false,
  margin_left: false,
  full_width: false,
  uppercase: true,
  link: false,
  loading: false,
};

Button.propTypes = {
  color: PropTypes.oneOf(['green', 'white', 'blue', 'red', 'orange']),
  type: PropTypes.string,
  text: PropTypes.string.isRequired,
  onClick: PropTypes.func,
  margin: PropTypes.bool,
  disabled: PropTypes.bool,
  border: PropTypes.bool,
  margin_left: PropTypes.bool,
  full_width: PropTypes.bool,
  uppercase: PropTypes.bool,
  link: PropTypes.bool,
  title: PropTypes.string,
  loading: PropTypes.bool,
};
